import TransactionCounts from "../../../components/Settings/Statistics/GraphsComponents/TransactionCounts";
import ProductivityTracker from "../../../components/Settings/Statistics/GraphsComponents/ProductivityTracker";
import DebitCreditAmount from "../../../components/Settings/Statistics/GraphsComponents/DebitCreditAmount";
import OdInterestSaved from "../../../components/Settings/Statistics/GraphsComponents/OdInterestSaved";
import CashCoveragePeriod from "../../../components/Settings/Statistics/GraphsComponents/CashCoveragePeriod";
import AccountsPerDay from "../../../components/Settings/Statistics/GraphsComponents/AccountsPerDay";
import IncomeOnIdleFunds from "../../../components/Settings/Statistics/GraphsComponents/IncomeOnIdleFunds";
import TransactionPerDay from "../../../components/Settings/Statistics/GraphsComponents/TransactionPerDay";

// Widget IDs
export const WIDGET_IDS = {
  TRANSACTION_COUNT: "transaction_count",
  PRODUCTIVITY_TRACKER: "productivity_tracker",
  DEBIT_CREDIT_AMOUNT: "debit_credit_amount",
  OD_INTEREST_SAVED: "od_interest_saved",
  CASH_COVERAGE_PERIOD: "cash_coverage_period",
  ACCOUNTS_PER_DAY: "accounts",
  INCOME_ON_IDLE_FUNDS: "income_on_idle_funds",
  TRANSACTION_PER_DAY: "transactions",
};

// Widget id to title lookup table for rendering widget headers
export const WIDGET_TITLES = {
  [WIDGET_IDS.TRANSACTION_COUNT]: "Transactions count",
  [WIDGET_IDS.PRODUCTIVITY_TRACKER]: "Productivity tracker",
  [WIDGET_IDS.DEBIT_CREDIT_AMOUNT]: "Debit and credit amount",
  [WIDGET_IDS.OD_INTEREST_SAVED]: "OD interest saved",
  [WIDGET_IDS.CASH_COVERAGE_PERIOD]: "Cash coverage period",
  [WIDGET_IDS.ACCOUNTS_PER_DAY]: "Accounts per day",
  [WIDGET_IDS.INCOME_ON_IDLE_FUNDS]: "Income on idle funds",
  [WIDGET_IDS.TRANSACTION_PER_DAY]: "Transactions per day",
};

// Title to widget id reverse lookup table
export const WIDGET_TITLE_TO_ID = Object.entries(WIDGET_TITLES).reduce(
  (acc, [id, title]) => {
    acc[title] = id;
    acc[title.toLowerCase()] = id;
    return acc;
  },
  {
    "Transaction count": WIDGET_IDS.TRANSACTION_COUNT,
  },
);

// Registry mapping backend widget_ids to React components
export const renderWidget = (widget) => {
  const { widget_id, filters } = widget;

  switch (widget_id) {
    case WIDGET_IDS.TRANSACTION_COUNT:
      return (
        <TransactionCounts
          flow="homeDashboard"
          autoFetch={true}
        />
      );

    case WIDGET_IDS.PRODUCTIVITY_TRACKER:
      return (
        <ProductivityTracker
          flow="homeDashboard"
          autoFetch={true}
        />
      );

    case WIDGET_IDS.DEBIT_CREDIT_AMOUNT:
      return (
        <DebitCreditAmount
          flow="homeDashboard"
          autoFetch={true}
        />
      );

    case WIDGET_IDS.OD_INTEREST_SAVED:
      return (
        <OdInterestSaved
          flow="homeDashboard"
          autoFetch={true}
        />
      );

    case WIDGET_IDS.CASH_COVERAGE_PERIOD:
      return (
        <CashCoveragePeriod
          flow="homeDashboard"
          autoFetch={true}
        />
      );

    case WIDGET_IDS.ACCOUNTS_PER_DAY:
      return (
        <AccountsPerDay
          flow="homeDashboard"
          autoFetch={true}
        />
      );

    case WIDGET_IDS.INCOME_ON_IDLE_FUNDS:
      return (
        <IncomeOnIdleFunds
          flow="homeDashboard"
          autoFetch={true}
        />
      );

    case WIDGET_IDS.TRANSACTION_PER_DAY:
      return (
        <TransactionPerDay
          flow="homeDashboard"
          autoFetch={true}
        />
      );

    default:
      return null;
  }
};
